export default function(elementWithTextToSelectAndCopy) {
  elementWithTextToSelectAndCopy.select(); // make sure that text is selected before copying to clipboard

  try {
    document.execCommand('copy');
  } catch (err) {
    console.log('Oops, unable to copy');
  }
}


// WEBPACK FOOTER //
// ./src/common/copyToClipboard.js